<template>
	<div class="ReActionBtns" v-if="!bIsDelited">
		<div class="actions">
			<p class="text-danger" v-if="bIsDelited">Удалено</p>
			<template v-for="(action,act_index) in  masActions">
				<base-switch v-if="action.actionType == 'switcher'" :key="act_index"
					v-model="action.action_model"
					type="primary"
					:on-text="action.label_on"
					:off-text="action.label_off"
					@change="DoApi(action)"
				></base-switch>
				<button v-if="action.actionType == 'btn_save'" :key="act_index" class="ml-3 btn btn-icon btn-simple btn-success" @click="DoApi(action)">
					<i class="tim-icons icon-book-bookmark"></i>
				</button>
				<button v-if="action.actionType == 'btn_custom'" :key="act_index" class="ml-3 btn btn-icon btn-simple btn-warning" @click="DoApi(action)">
					<i class="tim-icons" :class="action.icon"></i>
				</button>
				<button v-if="action.actionType == 'btn_edit'" :key="act_index" class="ml-3 btn btn-icon btn-simple btn-primary" @click="DoApi(action)">
					<i class="tim-icons icon-pencil"></i>
				</button>
				<button v-if="action.actionType == 'btn_del'" :key="act_index" class="ml-3 btn btn-icon btn-simple btn-danger" @click="DoApi(action)">
					<i class="tim-icons icon-trash-simple"></i>
				</button>
			</template>
		</div>
	</div>
</template>

<script>
	import { BaseSwitch } from 'src/components/index';
	// import swal from 'sweetalert2';
	export default {
		name: 'ReActionBtns',
		components: {
			BaseSwitch
		},
		props: {
			label: String,
			labelGoTo: {
				type:String,
				default: ''
			},
			masActions: Array,
		},
		data () {
			return {
				ver: 1,
				bIsDelited: false,
			}
		},
		computed: {

		},
		methods: {
			DoApi(allAction){
				if(this.$GVO.isEmpty(allAction.onClickApi)) return false;
				if(allAction.onClickApi.apiMethod == 'GOTO' && allAction.onClickApi.apiParam.obj == 'local'){
					this.$router.push({path: allAction.onClickApi.apiParam.to});
				}else{
					if(allAction.actionType == 'switcher'){
						if(allAction.changeState){
							// вызываем метод чтобы он обновил данные для апи при изменении состояния
							allAction.changeState(allAction.onClickApi, allAction.action_model);
						}
					}
					this.$GVO.ApiCall(allAction.onClickApi.apiMethod, allAction.onClickApi.apiParam)
					.then((objApi) => {
						if(objApi.success === true){
							// console.log(objApi);
							if(allAction.actionType=='btn_del'){
								this.bIsDelited=true;		
							}
							if(allAction.onSuccess)
								allAction.onSuccess(objApi);
						}else{
							this.$GVO.showAlert('Редактирование',objApi.msg);
							// alert(objApi.msg);
						}
					// 	else {
					// 	swal({
					// 		title: 'Ошибка данных',
					// 		buttonsStyling: false,
					// 		confirmButtonClass: 'btn btn-danger btn-fill',

					// 		html: `<div class="error-content">
					// 				<p>${objApi.msg}</p>
					// 			</div>`,
					// 	});

					// } 
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			}
		},
	}
</script>
<style>
	.ReActionBtns{
		display: flex;
		align-items: baseline;
		justify-content: flex-end;
		padding: 0px 5px;
	}
	.ReActionBtns label{
		font-weight: bold;
		font-size: 14px;
	}
	
	.ReActionBtns > div:nth-child(2){
		min-width:250px;
	}

	.ReActionBtns .bootstrap-switch{width: 70px !important; margin: 0;}
	.ReActionBtns .bootstrap-switch .bootstrap-switch-label{left: 55%;}
	.ReActionBtns .bootstrap-switch-container{width: 106px !important;}
</style>
